import { StepStatus } from '../enums/stepStatus.enum';
import { FormControl } from '@angular/forms';

export interface Step {
  id?: number|string;
  label: string;
  formControl?: FormControl;
  status: StepStatus;
}
